import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../firebase/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { doc } from 'firebase/firestore';

const UserContext = createContext();

export function UserProvider({ children }) {
    const [authUser, authLoading, authError] = useAuthState(auth);
    const [isLoggedIn, setIsLoggedIn] = useState(null); // null means "loading"

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => setIsLoggedIn(!!user));

        return () => unsubscribe();
    }, []);

    const userDocRef = authUser ? doc(db, 'users', authUser.uid) : null;
    const [profile, profileLoading, profileError] = useDocumentData(userDocRef);

    const loading = authLoading || profileLoading || profile === undefined;
    const error = authError || profileError;

    return (
        <UserContext.Provider value={{ profile: profile, loading, error, authUser, isLoggedIn: isLoggedIn }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    return useContext(UserContext);
}
